// The signed query better-auth's OAuth provider puts on the sign-in and consent
// pages: the authorize parameters plus `exp`, `ba_iat`, `ba_param` (the signed
// names) and `sig`. Read from the raw query string, never through the router
// (its search parsing would change the values and break the signature).

const SIGNED_NAMES = "ba_param";
/** Added by the server; not authorize parameters. */
const SERVER_ONLY = new Set(["sig", "exp", "ba_iat", "ba_param", "ba_pl"]);

/**
 * The signed part, to send back as `oauth_query` with the consent; null when
 * the page was opened outside an OAuth flow.
 */
export function signedOAuthQuery(search: string): string | null {
  const params = new URLSearchParams(search);
  if (!params.has("sig")) return null;
  const names = new Set(params.getAll(SIGNED_NAMES));
  if (names.size === 0) return null;
  const signed = new URLSearchParams();
  for (const [key, value] of params.entries())
    if (key === "sig" || key === SIGNED_NAMES || names.has(key))
      signed.append(key, value);
  return signed.toString();
}

/**
 * After signing in during an OAuth flow: the query to run authorize again
 * with (the server's marks dropped, and `login` taken out of `prompt`, or
 * authorize would send the person back here). null outside a flow.
 */
export function authorizeQueryFromSigned(search: string): string | null {
  const params = new URLSearchParams(search);
  if (!params.has("sig") || !params.has("client_id")) return null;
  const query = new URLSearchParams();
  for (const [key, value] of params.entries()) {
    if (SERVER_ONLY.has(key)) continue;
    if (key === "prompt") {
      const rest = value.split(" ").filter((p) => p !== "" && p !== "login");
      if (rest.length > 0) query.append(key, rest.join(" "));
      continue;
    }
    query.append(key, value);
  }
  return query.toString();
}
